import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const ModalMeta: ComponentMeta = {
  componentName: "Modal",
  package: "@mijadesign/web",
  title: "对话框",
  description: "模态对话框",
  category: ComponentCategory.FEEDBACK,
  icon: "ExpandOutlined",
  canHaveChildren: true,
  editorDnd: {
    // 浮层编辑态只允许内容区承接投放，避免遮罩或标题区域误投放。
    partialDropRegion: true,
    overlayEditMode: "modal",
  },
  visibleInComponentPanel: true,
  designToken: {
    fields: [
      { name: "headerBg", label: "头部背景", type: "color" },
      { name: "contentBg", label: "内容背景", type: "color" },
      { name: "titleColor", label: "标题颜色", type: "color" },
      {
        name: "borderRadiusLG",
        label: "大圆角",
        type: "number",
        min: 0,
        max: 48,
      },
    ],
  },
  props: [
    {
      name: "title",
      label: "标题",
      type: PropType.STRING,
      defaultValue: "对话框标题",
      group: "基础",
    },
    {
      name: "open",
      label: "显示",
      type: PropType.BOOLEAN,
      defaultValue: true,
      bindable: true,
      bindSources: ["state"],
      group: "状态",
    },
    {
      name: "width",
      label: "宽度",
      type: PropType.NUMBER,
      defaultValue: 520,
      group: "布局",
    },
    {
      name: "centered",
      label: "垂直居中",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "布局",
    },
    {
      name: "closable",
      label: "显示关闭按钮",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "基础",
    },
    {
      name: "mask",
      label: "显示遮罩",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "样式",
    },
    {
      name: "maskClosable",
      label: "点击遮罩关闭",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "功能",
    },
    {
      name: "okText",
      label: "确定按钮文字",
      type: PropType.STRING,
      defaultValue: "确定",
      group: "按钮",
    },
    {
      name: "cancelText",
      label: "取消按钮文字",
      type: PropType.STRING,
      defaultValue: "取消",
      group: "按钮",
    },
    {
      name: "confirmLoading",
      label: "确定按钮加载中",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "footer",
      label: "底部内容",
      type: PropType.JSON,
      description: "null 隐藏底部",
      group: "内容",
    },
  ],
  defaultProps: {
    title: "对话框标题",
    open: true,
    width: 520,
  },
  defaultStyle: {
    width: 520,
  },
  npm: {
    package: "antd",
    exportName: "Modal",
  },
  snippet: {
    componentName: "Modal",
    package: "antd",
    props: { title: "对话框标题", open: true, width: 520 },
    children: [],
  },
};
